export { default } from './seo'
